export { default } from './seo'
